import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title
  ) {

  }

  ngOnInit() {
    if ( this.authService.checkAuthToken() ) {
      this.authService.getAuthCookie();
    }

    setTimeout(() => {
      if ( this.route.snapshot.queryParamMap.get('RH') === '1' ) {
        this.loadCss(true);
      } else {
        this.loadCss();
      }
    }, 100);
  }

  loadCss(isRh = false) {
    const style = document.createElement('link');
    const custom = document.createElement('link');
    const grapes = document.createElement('link');
    const favicon = document.createElement('link');

    grapes.type = custom.type = style.type = 'text/css';
    grapes.rel = custom.rel = style.rel = 'stylesheet';

    favicon.rel = 'icon';
    favicon.type = 'image/x-icon';

    if ( environment.app === 'MyDesign3' ) {
      this.titleService.setTitle('MyDesign v3');
      style.href = '/assets/templates/mydesign.css';
      custom.href = '/assets/templates/mydesign-custom.css';
      grapes.href = '/assets/templates/mydesign-grapes.css';
      favicon.href = '/assets/templates/mydesign.ico';
    } else {
      this.titleService.setTitle('Designly');
      favicon.href = '/assets/templates/designly.ico';
      if ( typeof this.authService.auth !== 'undefined'
        && ( typeof this.authService.auth.brandid !== 'undefined' &&
        this.authService.auth.brandid === '6' ) || isRh ) {
          style.href = '/assets/templates/rh.css';
          custom.href = '/assets/templates/rh-custom.css';
          grapes.href = '/assets/templates/rh-grapes.css';
      } else {
        style.href = '/assets/templates/designly.css';
        custom.href = '/assets/templates/designly-custom.css';
        grapes.href = '/assets/templates/designly-grapes.css';
      }

      if ( this.router.url === '/login' && !isRh ) {
        style.href = '/assets/templates/designly.css';
        custom.href = '/assets/templates/designly-custom.css';
        grapes.href = '/assets/templates/designly-grapes.css';
      }
    }

    document.getElementsByTagName('head')[0].appendChild(favicon);
    document.getElementsByTagName('head')[0].appendChild(grapes);
    document.getElementsByTagName('head')[0].appendChild(custom);
    document.getElementsByTagName('head')[0].appendChild(style);

    // tslint:disable-next-line:max-line-length
    console.log(`%c${environment.app} Notice: This is a browser feature intended for developers. Do not paste anything here.`, `color: red; font-size: 30px`);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts